import React from "react";
import AreaChartMonthly from "../../AdminComponents/AreaChartMonthly";
import PieCharts from "../../AdminComponents/PieChart";
import BarCharts from "../../AdminComponents/BarCharts";
import { Link } from "react-router-dom";

const Analytics = () => {
  return (
    <div className=" px-[10px] md:px-[20px] lg:px-[3%]">
      <Link to="/admin">
        <img className=" h-16" src="/utils/back.png" alt="" />
      </Link>
      <div className="grid grid-cols-1 mx-1 ">
        <div className="pie chart bg-white  h-[40vh] my-2">
          <AreaChartMonthly />
        </div>
        <div className=" grid grid-cols-1">
          <div className="pie chart bg-white h-[40vh] mb-2">
            <PieCharts />
          </div>
          <div className="pie chart bg-white h-[60vh] mb-5">
            <BarCharts />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
